import { Component, Input, Output, EventEmitter, TemplateRef, SimpleChanges } from '@angular/core';
import { ParentCompanyFinancials, ParentCompanyFinancialsMeta } from '../pharma-page.model';
import { Dictionary } from 'src/app/store/models/common_types';

@Component({
  selector: 'app-pharma-financial-filter',
  templateUrl: './pharma-financial-filter.component.html',
  styleUrls: ['./pharma-financial-filter.component.scss']
})
export class PharmaFinancialFilterComponent {
  @Input() loading: boolean;
  @Input() activePanel = "";
  @Input() refreshCurrentPanel = false;
  @Input() panel = {} as any;
  @Input() filter ={} as any;
  @Input() data: ParentCompanyFinancials = {
    meta: {} as ParentCompanyFinancialsMeta
  };
  @Input() amountFormatter: TemplateRef<any>;
  @Output() onChange: EventEmitter<any> = new EventEmitter();

  id: number;
  indexBeingEdited: number;
  selected_line_item: string;
  label: string;
  selected_year: string;
  minValue: number;
  maxValue: number;
  selected_min: number;
  selected_max: number;
  magnitude: string;
  currency: string;

  ngOnChanges(changes: SimpleChanges) {
    // if(changes.filter) {
    //   if(this.filter.financials && this.filter.financials.length) {
    //     this.filter.financials = this.filter.financials.map((fin) => {
    //       return {
    //         id: fin.id,
    //         selected_line_item: fin.selected_line_item,
    //         selected_max: fin.selected_max,
    //         selected_min: fin.selected_min,
    //         selected_year: fin.selected_year,
    //       }
    //     })
    //   }
    // }
    if(changes.data && this.data && this.data.meta) {
      this.id = null;
      this.indexBeingEdited = null;
      if(!this.selected_line_item || !this.selected_year) {
        if(!this.selected_line_item) {
          this.selected_line_item = this.data.meta.defaultItem;
        }
        if(!this.selected_year) {
          this.selected_year = this.data.meta.defaultyear;
        }
      }
      this.changeMinMax();
    }
  }
  customSkeletonConfig = {
    skeletonType: "list",
    config: {
      list: {
        noOfListItems: 8,
      },
    },
  };

  getLILabel(item) {
    let itemObj = this.data.meta.lineItemList.find((obj) => obj.key === item);
    return itemObj && itemObj.label;
  }
  getYearLabel(item) {
    let itemObj = this.data.meta.yearList.find((obj) => obj.key === item);
    return itemObj && itemObj.label;
  }

  getFinancials() {
    return this.filter.financials.filter((fin) => fin.id !== this.id);
  }
  // getValue(key) {
  //   return this.data.meta.minMaxCombinations[this.selected_line_item][this.selected_year][key];
  // }
  changeMinMax() {
    // if(this.id // If some pre-selected value is being edited.
    //   && this.selected_line_item === this.filter.financials[this.indexBeingEdited].selected_line_item
    //   && this.selected_year === this.filter.financials[this.indexBeingEdited].selected_year)
    //   {
    //     this.selected_min = this.filter.financials[this.indexBeingEdited].selected_min;
    //     this.selected_max = this.filter.financials[this.indexBeingEdited].selected_max;
    //     this.minValue = this.selected_min;
    //     this.maxValue = this.selected_max;
    // } else {
      this.selected_min = this.data.meta.minMaxCombinations[this.selected_line_item][this.selected_year]['min_value'];
      this.selected_max = this.data.meta.minMaxCombinations[this.selected_line_item][this.selected_year]['max_value'];
      this.minValue = this.selected_min;
      this.maxValue = this.selected_max;
    // }
    
  }

  // getMappedPayload() {
  //   let payload = {...this.filter};
  //   if(!payload.financials) {
  //     payload.financials = [];
  //   }
  //   let financials = payload.financials.map((fin) => {
  //     return {
  //       id: fin.id,
  //       selected_line_item: fin.selected_line_item,
  //       selected_max: fin.selectedMax,
  //       selected_min: fin.selectedMin,
  //       selected_year: fin.selectedYear,
  //     }
  //   });
  //   payload.financials = financials;
  //   return payload;
  // }
  addFinancial() {
    let payload = {...this.filter};
    if(!payload.financials) {
      payload.financials = [];
    }
    if(this.id) { //if id exists, then its a case of update.
      let dataToUpdate = payload.financials.find((obj) => obj.id === this.id);
      dataToUpdate.selected_line_item= this.selected_line_item;
      dataToUpdate.selected_year= this.selected_year;
      dataToUpdate.selected_min= this.selected_min;
      dataToUpdate.selected_max= this.selected_max;
    } else {
      payload.financials.push({
        id: payload.financials.length +1, // Not starting id from 0
        selected_line_item: this.selected_line_item,
        selected_year: this.selected_year,
        selected_min: this.selected_min,
        selected_max: this.selected_max,
      });
    }
    this.id = null;
    // delete payload.meta;
    this.onChange.emit(payload);
  }

  onRangeChange(range) {
    this.selected_min = range.min;
    this.selected_max = range.max;
  }

  onDelete(idx) {
    let payload = {...this.filter};
    if(payload.financials) {
      payload.financials.splice(idx, 1);
      // delete payload.meta;
      // reset the id of each financial
      payload.financials.forEach((financial, index) => {
        financial.id = index +1;
      })
      this.onChange.emit(payload);
    }
    
  }

  onEdit(idx) {
    this.id = this.filter.financials[idx].id;
    this.indexBeingEdited = idx;
    this.selected_line_item = this.filter.financials[idx].selected_line_item;
    this.selected_year = this.filter.financials[idx].selected_year;
    this.selected_min = this.filter.financials[idx].selected_min;
    this.selected_max = this.filter.financials[idx].selected_max;
    // this.minValue = this.selected_min;
    // this.maxValue = this.selected_max;
  }
}
